<template>
  <v-list>
    <v-list-tile to="/" :disabled="disableNavPoint('welcome')" exact>
      <v-list-tile-action>
        <v-icon class="green--text" html="about us">home</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>Home</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>

    <navigation v-for="geo in geoTypes" :item="geo" :key="geo.shortName"></navigation>

    <v-list-tile to="about-us" :disabled="disableNavPoint('about')">
      <v-list-tile-action>
        <v-icon dark class="green--text" html="about us">info</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>About Us</v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
  import Navigation from '@/components/Navigation';
  import geoTypes from '@/components/converter/helpers/geoTypes';

  export default {
    components: {
      navigation: Navigation,
    },
    data() {
      return {
        geoTypes,
      };
    },
    watch: {
      '$route.name': 'disableNavPoint',
    },
    methods: {
      disableNavPoint(name) {
        // TODO: This is being called too often (3 times) instead of once!
        return this.$route.name === name;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue